import React, { FC, useState } from 'react';

// components
import BasicButton from '../../../components/buttons/basicButton';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';

// constants
import envConfig from '../../../services/env-config';

interface ContentTagProps {
    formulaId: number;
}

const ContentTag: FC<React.PropsWithChildren<ContentTagProps>> = ({
    formulaId,
}) => {
    const [hasCopied, setCopy] = useState<boolean>(false);
    const url =
        envConfig.CONTENT_API_BASE_URL +
        '/in-app?contact_id={{${user_id}}}' +
        `&campaign_id=${formulaId}`;

    const clickHandler = () => {
        setCopy(true);
        navigator.clipboard.writeText(url);

        setTimeout(() => setCopy(false), 1000);
    };

    return (
        <Container>
            <Heading>Get your Content URL</Heading>
            <Text>
                Click below to copy the URL portion of your Connected <br />{' '}
                Content Tag for this message.
            </Text>
            <BasicButton
                name={hasCopied ? 'Copied!' : 'Copy'}
                disabled={hasCopied}
                action={clickHandler}
            />
        </Container>
    );
};

const Container = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '80%',
    height: '500px',
    gap: aampeTheme.spacing(2),
    paddingTop: aampeTheme.spacing(7),
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.default,
}));

const Heading = styled.p(() => ({
    fontWeight: 'bold',
    color: aampeTheme.colors.gray800,
}));

const Text = styled.p(() => ({
    color: aampeTheme.colors.gray800,
    textAlign: 'center',
    fontSize: '14px',
}));

export default ContentTag;
